module.exports = __webpack_public_path__ + "img/greyPacket.731a4fa4.png";